import React from 'react';
import { Button } from '@/components/ui/button.tsx';

interface FinishActionsProps {
  currentCategoryIdx: number;
  onCopyAnswers: () => void;
  onDownload: () => void;
  onFinish: () => void;
  onNext: () => void;
  onPrevious: () => void;
  totalCategories: number;
}

const FinishActions: React.FC<FinishActionsProps> = ({
  currentCategoryIdx,
  onCopyAnswers,
  onDownload,
  onFinish,
  onNext,
  onPrevious,
  totalCategories
}) => {
  const isLastCategory = currentCategoryIdx === totalCategories - 1;
  const isFirstCategory = currentCategoryIdx === 0;

  return (
    <div className="flex items-center justify-between max-w-5xl mx-auto w-full pb-8 pt-2">
      <Button 
        className="min-w-[120px]" 
        disabled={isFirstCategory} 
        onClick={onPrevious} 
        type="button" 
        variant="outline"
      >
        &larr; Previous
      </Button>
      <div className="flex gap-2">
        {isLastCategory ? (
          <>
            <Button className="min-w-[120px]" onClick={onDownload} type="button">
              Download Answers
            </Button>
            <Button className="min-w-[120px] ml-2" onClick={onCopyAnswers} type="button" variant="secondary">
              Copy Answer
            </Button>
            <Button className="min-w-[120px] ml-2" onClick={onFinish} type="button">
              Finish
            </Button>
          </>
        ) : (
          <>
            <Button className="min-w-[120px]" onClick={onNext} type="button">
              Next &rarr;
            </Button>
            <Button className="min-w-[120px] ml-2" onClick={onFinish} type="button">
              Finish
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default FinishActions;